export default __webpack_public_path__ + "static/media/mps.33b9aec2.webp";